import React from 'react';
import { Box, Typography, Modal, TextField, Button, Divider } from '@mui/material';
import { footerStyle, headerStyle, inputStyle, modalStyle } from '../OrderEntry/styles';
import { tokens } from '../../Common/designTokens';

const FilterNameModal = ({ open, onClose, filterName, onFilterNameChange, onSave }) => {
  const maxLength = 15;

  const handleSave = () => {
    if (filterName.trim()) {
      onSave(filterName);
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="filter-name-modal-title">
      <Box sx={{
        ...modalStyle,
        width: "500px",
      }}>
        <Box sx={headerStyle}>
          <Typography id="filter-name-modal-title" variant="h6" fontWeight="bold" sx={{ color: tokens.colors.fontColour }}>
            Save Filter
          </Typography>
        </Box>
        <Box sx={{ pt: 3, pl: 3, pr: 3 }}>
          <TextField
            autoFocus
            InputProps={{
              disableUnderline: true,
            }}
            fullWidth
            label="Filter Name"
            value={filterName}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= maxLength) {
                onFilterNameChange(value);
              }
            }}
            variant="filled"
            inputProps={{ maxLength }} // Enforce max length at the input level
            helperText={`${filterName.length}/${maxLength} characters`}
            sx={{
              ...inputStyle,
              "& .MuiFormHelperText-root": { color: tokens.colors.fontColour85 },
              // Override the default underline for the filled variant:
              "& .MuiFilledInput-underline:before": {
                borderBottom: `1px solid ${tokens.colors.bodyBorderColor50}`,
              }
            }}
          />
          <Box sx={{ mt: 3, mx: -3 }}>
            <Divider sx={{ borderColor: tokens.colors.bodyBorderColor50 }} />
          </Box>
          <Box sx={{
            ...footerStyle,
            borderTop: "none",
            "& > :not(style) + :not(style)": {
              ml: 2,
            },
          }}>
            <Button variant="outlined" onClick={onClose} sx={{ textTransform: "none", px: 4, py: 1, borderRadius: "8px",  }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!filterName.trim()}
              sx={{ textTransform: "none", px: 4, py: 1, borderRadius: "8px", backgroundColor: tokens.palette.primary, color: tokens.colors.white, '&:hover': { backgroundColor: tokens.palette.primaryA80 } }}
            >
              Save & Apply
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterNameModal;